import isArray from 'lodash-es/isArray';
import isString from 'lodash-es/isString';
import tinycolor from 'tinycolor2';

export default function useBackgroundIsDark(background: Background | null): boolean {
    const { color = null, imageFade = null } = background || {};
    let backgroundColor = null;
    if (isString(imageFade)) {
        backgroundColor = imageFade;
    } else if (isArray(imageFade)) {
        [backgroundColor = null] = imageFade;
    } else if (color !== null) {
        backgroundColor = color;
    }
    return backgroundColor !== null ? tinycolor(backgroundColor).isDark() : false;
}
